import React from 'react';

export default class SSDContent extends React.Component {

    renderBlock(id, block, oldBlock) {

        const stateMap = {"i": "É", "v": "H", "e": "T"};
        return <div key={id} className="ssd-block">
                <div className="ssd-block-header">
                    <div className="ssd-block-header-id">{id}.</div>
                    <div className="ssd-block-header-label">#P/E:</div>
                    <div className="ssd-block-header-value">
                        {oldBlock && oldBlock.age !== block.age && <span className="ssd-replace-item">{oldBlock.age}</span>}
                        {block.age}
                    </div>
                </div>
                <table className="ssd-block-content">
                    <tbody>
                        {block.pages.map((pg, ix) =>
                            <tr key={ix} className="ssd-block-content-row">
                                <td className="ssd-block-content-state">
                                    {oldBlock && oldBlock.pages[ix].state !== pg.state && <span className="ssd-replace-item">{stateMap[oldBlock.pages[ix].state]}</span>}
                                    {stateMap[pg.state]}
                                </td>
                                <td className="ssd-block-content-page">
                                    {oldBlock && oldBlock.pages[ix].page !== pg.page && <span className="ssd-replace-item">{oldBlock.pages[ix].page === -1 ? "?" : oldBlock.pages[ix].page}</span>}
                                    {pg.page === -1 ? "?" : pg.page}
                                </td>
                            </tr>                        
                        )}
                    </tbody>
                </table>
            </div>;
    }

    render() {
        const blocks = this.props.content?.blocks.map((blk, ix) => this.renderBlock(ix, blk, (this.props.markChanges && this.props.prevContent) ? this.props.prevContent.blocks[ix] : null));
        return <div className="ssd-content">
                {blocks}
            </div>;
    }
}